import { render, staticRenderFns } from "./TheProfileFieldsetAssistant.vue?vue&type=template&id=265d9baa&"
import script from "./TheProfileFieldsetAssistant.vue?vue&type=script&lang=js&"
export * from "./TheProfileFieldsetAssistant.vue?vue&type=script&lang=js&"
import style0 from "./TheProfileFieldsetAssistant.vue?vue&type=style&index=0&id=265d9baa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports